import React, { useState } from 'react';

const SendToken = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSend = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/email/send-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('✅ Token enviado al correo. Revisá tu bandeja de entrada o spam.');
      } else {
        setMessage(`❌ ${data.error || 'Error al enviar el token.'}`);
      }
    } catch (error) {
      console.error('Error al conectar:', error);
      setMessage('❌ Error de conexión con el servidor.');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: 20 }}>
      <h2>Solicitar verificación</h2>
      <input
        type="email"
        placeholder="Tu correo"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: '100%', marginBottom: 10, padding: 8 }}
      />
      <button onClick={handleSend} style={{ width: '100%', padding: 10 }}>
        Enviar código
      </button>
      {message && <p style={{ marginTop: 15 }}>{message}</p>}
    </div>
  );
};

export default SendToken;